import React, { useState, useContext, useEffect, useRef } from 'react';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Subtitle2, Title3, Body1, Caption1, Subtitle1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Image, Card, InfoLabel, ButtonProps, Tooltip, Link, Textarea, ToggleButton, Field } from "@fluentui/react-components";
import { Info20Regular, Open20Regular, GroupList20Regular, TrayItemRemove20Filled, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize20Regular, Dismiss16Regular, DismissSquare24Filled, FilterAdd20Filled, Info20Filled, Delete20Regular, AddSquare20Regular, Info16Filled } from "@fluentui/react-icons";
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, secondaryIcon, overflowDivider, buttonContent, inputFieldCSS, dividerWidthStyle, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, buttonDisabled, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../../styles/customStyles";
import { DatePicker, DefaultButton, PrimaryButton, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { Breadcrumbs } from '../../../components/breadcrumbs/breadcrumbs.component';
import { SideMenu } from '../../../components/side_menu/inline_side_menu.component';
import { OverflowSetCustomExample } from '../../../components/side_menu/overFlowSet.component';
import { SearchBar } from '../../../components/searchbar/searchbar.component';
import { MenuDropdown } from '../../../components/dropdown/menu.component';
import { DropdownComponent } from '../../../components/dropdown/dropdown.component';
import { Pagination } from '../../../components/pagination/pagination.component';
import { ToastComponent } from '../../../components/toast/toast.component';
import { SkeletonDataTable } from '../../../components/skeleton/skeletonDataTable';
import OverLay from '../../../components/side_menu/overlay_side_menu.component';
import FullScreenButton from '../../../components/fullscreen/fullScreen.component';
import { usePermissionStore } from "../../../Store/permissionStore";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from '../../../hooks/globalContext';
import { DatepickerComponent } from '../../../components/picker/datepicker.component';
import { DataTable } from "../../../components/data_table/data_table.component";
import { CheckBox } from '../../../components/checkbox/checkbox_component';
import { FileDownloadComponent } from '../../../components/fileExport/file.export.component';
import FileUploadComponent from '../../../components/fileImport/file.import.component';
import DialogBox from '../../../components/dialog/dialog.component';
import { InfoBar } from '../../../components/infoBar/infoBar.component';
import { RadioGroups } from '../../../components/radio_group/radioGroup.component';
import { CSVLink } from 'react-csv';
import { DynamicDialog } from '../../../components/dialog/dynamic.dialog.component';
import { CensusData, CheckboxState } from "../../../interfaces/devices/census_interface";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
// import {DateComponent} from '../dateComponent';
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { Asset_event_func } from './asset_event_func';
import { Inputs } from '../../../components/textarea/input.component';
import { RJSFSchema, ValidationData, ValidatorType } from '@rjsf/utils';
import { SearchPages } from '../../../components/side_menu/InlineSidenav';

const Asset = () => {
    const contextValue: any = useContext(GlobalContext);
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [isOverlayFilter, setIsOverlayFilter] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [errorToast, setErrorToast] = useState(false);
    const [final_data, set_final_data]: any = useState<CensusData[] | null>(null);
    const [devicesTableData, setDevicesTableData] = useState([]);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [searchVal, setSearchVal] = useState("");
    const [overLayData, setOverLayData] = useState<any>({});
    const [totalPages, setTotalPages] = useState<number>(1);
    const [currentPageNo, setCurrentPageNo] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [selectedTableData, setSelectedTableData] = useState([]);
    const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [isRefresh, setIsRefresh]: any = useState('');
    const [toastMessage, setToastMessage] = useState('');
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [tableColumnsData, setTableColumnsData] = useState([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [exportData, setExportData]: any = useState([]);
    const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
    const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
    const [isDeletedata, setIsDeletedata]: any = useState(false);
    const [loading, setLoading] = useState(true);
    const [isOsName, setOsName] = useState([]);
    const [isIconEnabled, setIconEnabled] = useState(false);
    const [overlayName, setOverlayName] = useState('');
    const formRef = useRef(null);
    const handle = useFullScreenHandle();
    const { permissions } = usePermissionStore();
    const navigate = useNavigate();
    var tenantName = contextValue.tenantName;
    const [isChecked, setChecked] = useState<CheckboxState>({
        expungeAsset: true,
        expungeEvent: true,
        expungePatch: true
    });
    const [loadTableData, setLoadTableData] = useState(true);
    const [dartList, setDartList] = useState([]);
    const [isdeletedisabled, setDeleteDisabled] = useState(true);
    const [deleteAsset, setDeleteAsset]: any = useState(false);
    const [classificationNameValidation, setClassificationNameValidation]: any = useState(true);
    var nameValidationTimer = useRef(null);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
    const [editBtnClicked, setEditBtnClicked]: any = useState(false);
    const [jsonData, setJsonData]: any = useState({});
    const [uiData, setUiData] = useState({});
    const [toastAlertCreate, setToastAlertCreate] = useState(false)
    const [toastAlertEdit, setToastAlertEdit] = useState(false)
    const [toastAlertDelete, setToastAlertDelete] = useState(false)
    const [toastAlertError, setToastAlertError] = useState(false)
    const [rowID, setRowID]: any = useState(null);
    const [importedDataInserted, setImportedDataInserted] = useState<any>(false);
    const [selectedAsset, setSelectedAsset]: any = useState();
    const [formData, setFormData]: any = useState({
        name: '',
        description: ''
    });
    const [troubleshooterList, setTroubleshooterList] = useState([])
    const [selectedTroubleshooterList, setSelectedTroubleshooterList] = useState([]);

    const buttonref: any = useRef(null);
    const handleOutsideButton = () => {
        buttonref?.current?.click();
    };

    useEffect(() => {
        if (nameValidationTimer.current) {
            clearTimeout(nameValidationTimer.current);
        }

        nameValidationTimer.current = setTimeout(() => {
            //   formData.name.length > 0 && setAutomationName(formData.name);
            formData.name.length === 0 && setClassificationNameValidation(true);
        }, 700);
    }, [formData]);

    useEffect(() => {
        if (filterArray.length > 0) { setResetDisabled(false) }
    }, [filterArray])
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    // NOTE THAT THIS IS A HARDCODED DATA, NOT AN ACTUAL DATA FROM DATABASE, HAVE TO MAKE IT DYNAMIC


    // REACT JSON FORM RENDERING
    const handleNewFormChange = (e: any) => {
        setFormData({
            ...formData,
            jsonData: e.formData
        });
    }

    const handleOnCLickEdit = (val: any) => {
        setLoading(true);
        setRowID(val.id);
        setSelectedAsset(val.query)
        localStorage.setItem('selectedAssetOrEventQuery', val.query);
        contextValue.setSelectedAssetRow(val.query);

        navigate('results');
        setIsRefresh('');
    }

    const handleEdit = (val: any) => {
        setLoading(true);
        setRowID(val.id);
        setOverlayName('editAsset');
        setFormData(JSON.parse(val?.formData))
        setOverlayOpen(true);
        setEditBtnClicked(true);
        // setReadOnly(true);
    }

    const handleAddBtnClick = () => {
        setCurrentPageNo(1);
        setOverlayName('addAsset');
        setRowID(null);
        setEditBtnClicked(false);
        setFormData({
            name: '',
            description: '',
            jsonData: { conditional: [{}] },
            fromDate: ''
        });

        setTimeout(() => {
            setOverlayOpen(true);
        }, 100);
    }

    useEffect(() => {
        if (toastAlertDelete) {
            setIsToast(true)
            setToastMessage('Asset deleted successfully');
            // setIsRefresh('success');
        } else {
            setToastMessage('');
            setIsToast(false)
        }
    }, [toastAlertDelete])

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9_ ]*$/;
        const regexN = /^[0-9]*$/;

        if (name === 'filter' && dropDownValue1 === ("Query name")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Created By")) {
            if (regexN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Description")) {
            if (regexS.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
    }

    const handleFilterArray = (): any => {
        const value1 = dropDownValue1
        const value2 = dropDownValue2;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setLoading(true);
        setDropDownValue1('');
        setDropDownValue2('');
    }

    const handleCloseFilter = (index: any): any => {
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        !isOverlayFilter && setLoading(true);

        setIsOverlayFilter(false);
    }

    useEffect(() => {
        if (overlayOpen) {
            const element = document.getElementById("fluent-default-layer-host");
            if (element) {
                element.style.zIndex = '9999999';
            }
        } else {
            editBtnClicked && setEditBtnClicked(false);
            overlayName?.length > 0 && setOverlayName('');
        }
    }, [overlayOpen]);

    // Data table column name code starts here
    var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    useEffect(() => {
        contextValue?.tableColumnsData?.Search?.Asset.forEach((val) => {
            if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
                if (val.key === "created_on_timezoned" || val.key === "Last_asset_date_timezoned") {
                    tableColumns[val.priority] = ({
                        key: val.key,
                        label:
                            <>
                                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                                    <StackItem>
                                        <Body1Strong>{`${val.name}`}</Body1Strong>
                                    </StackItem>
                                    <StackItem align="center">
                                        <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                                            <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                                        </Tooltip>
                                    </StackItem>
                                </Stack>
                            </>
                    });
                } else {
                    tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
                }
            }

            if (val.display.filter.toLocaleLowerCase() === "yes") {
                filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
            }
        });

        setTableColumnsData(tableColumns);
        setFilterColumnsData(filterColumns);

        contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Search?.Asset.filter((val) => val.priority >= 0));

        contextValue.setManageViewPageDetails({ module: "Search", page: "Asset" });
    }, [contextValue.tableColumnsData]);

    var tempTableData: any = [];
    var menuLists: any = [];
    useEffect(() => {
        // Data table values append code starts here
        final_data !== undefined && final_data !== null
            ? final_data?.map((val: any, index: any) => {
                {
                    permissions.includes("all") || permissions.includes("asset_Fullaccess") ?
                        tempTableData.push({
                            id: val.id,
                            checkbox: val.status === 'Attached' ? 'hide' : 'show',
                            Query_name: { label: <Button id="ButtonHover" style={buttonContent} onClick={(e: any) => { handleEdit(val) }} appearance="transparent" size="small"> {val.name} </Button> },
                            description: { label: <Caption1>{val.description}</Caption1> },
                            Create_by: { label: <Caption1>{val.createdBy}</Caption1> },
                            created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
                            created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
                            Last_asset_date: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
                            Last_asset_date_timezoned: { label: <Caption1> {val.lastModified ? convertToLocalTimezone(val.lastModified, userTimeZone) : '-'} </Caption1> },
                            Status: { label: <Button id="ButtonHover" style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> Result </Button> },
                        })
                        :
                        permissions.includes("asset_ReadandExport") ?
                        tempTableData.push({
                            id: val.id,
                            checkbox: val.status === 'Attached' ? 'hide' : 'show',
                            Query_name: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Button style={buttonContent} appearance="transparent" size="small"> {val.name} </Button>
                                    </Tooltip>
                            },
                            description: { label: <Caption1>{val.description}</Caption1> },
                            Create_by: { label: <Caption1>{val.createdBy}</Caption1> },
                            created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
                            created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
                            Last_asset_date: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
                            Last_asset_date_timezoned: { label: <Caption1> {val.lastModified ? convertToLocalTimezone(val.lastModified, userTimeZone) : '-'} </Caption1> },
                            Status: { label: <Button id="ButtonHover" style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> Result </Button> },
                        })
                        :
                        tempTableData.push({
                            id: val.id,
                            checkbox: 'hide',
                            Query_name: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Button style={buttonContent} appearance="transparent" size="small"> {val.name} </Button>
                                    </Tooltip>
                            },
                            description: { label: <Caption1>{val.description}</Caption1> },
                            Create_by: { label: <Caption1>{val.createdBy}</Caption1> },
                            created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
                            created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
                            Last_asset_date: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
                            Status: { label: <Button style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> Status </Button> },

                        })
                }
            }) : (tempTableData = []);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
        }, 500);
    }, [final_data, permissions, formData]);
    // Data table values append code ends here

    useEffect(() => {
        var tempExportData: any = [];

        exportDetails?.length > 0 && exportDetails.map((val: any) => {
            tempExportData.push({
                'Query Name': val.name,
                'Description': val.description,
                'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
                'Created On': convertToExcelFormat(val.createdOn),
                'Last Modified': val.modifiedOn ? convertToExcelFormat(val.modifiedOn) : "-",
            });
        });

        setExportData(tempExportData);
    }, [exportDetails]);

    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                {/* <Stack tokens={{childrenGap:10}} horizontal> */}
                <StackItem>
                    {
                        permissions.includes("all") || permissions.includes("asset_Fullaccess") ? (
                            <StackItem onClick={handleAddBtnClick}>
                                <Button shape="circular" disabled={loading} appearance="subtle" size="small" >
                                    <Stack tokens={{ childrenGap: 6 }}>
                                        {/* <StackItem><Text></Text></StackItem> */}
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> {loading ? <AddSquare20Regular {...secondaryIcon} /> : <AddSquare20Regular {...primaryIcon} />} </StackItem>
                                                <StackItem> <Caption1> Create Asset Query </Caption1> </StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                </Button>
                            </StackItem>
                        ) :
                            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                <Button shape="circular" appearance="subtle" size="small" disabled>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem><Text></Text></StackItem>
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                                                <StackItem><Caption1> Create Asset Query </Caption1></StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                </Button>
                            </Tooltip>
                    }
                </StackItem>

                <StackItem> <Divider vertical /> </StackItem>

                <StackItem>
                    <DialogBox
                        headerButton={
                            <>
                                <Button shape="circular" appearance="transparent" size="small"
                                    disabled={isdeletedisabled ? true : false} >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            {/* <Delete20Regular {...primaryIcon} />  */}
                                            {isdeletedisabled
                                                ? (<Delete20Regular {...secondaryIcon} />)
                                                : (<Delete20Regular {...primaryIcon} />)
                                            }
                                        </StackItem>
                                        <StackItem> <Caption1> Delete </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        }

                        content="Please confirm if you want to proceed with deleting the asset."

                        footer=
                        {
                            <>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                        <Button shape="circular" appearance="primary" onClick={() => { setDeleteAsset(true); setLoading(true); }} size="small">Confirm</Button>
                                    </StackItem>
                                    <StackItem>
                                        <Button shape="circular" size="small">Cancel</Button>
                                    </StackItem>
                                </Stack>
                            </>
                        }
                    />
                </StackItem>

                <StackItem> <Divider vertical /> </StackItem>

                <StackItem>
                    <Button shape="circular"
                        size="small"
                        appearance="subtle"
                        disabled={loading}
                        onClick={() => {
                            setCurrentPageNo(1);
                            setIsRefresh('true');
                            setLoading(true);
                            setRefreshToast(true);
                            setLoadTableData(true);
                        }}
                    >
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>

                    {permissions.includes("all") || permissions.includes("asset_Fullaccess") || permissions.includes("asset_ReadandExport") ?
                        <>
                            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_Asset_List.csv`} >
                            </CSVLink>
                            <Button shape="circular" disabled={loading || tableData.length === 0} size="small" appearance="subtle"
                                onClick={() => { setExportBtnClicked(true); }}  >
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                                </Stack>
                            </Button>
                        </>
                        :
                        <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                            <Button shape="circular" appearance="subtle" size="small" disabled>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                            <StackItem><Caption1> Export </Caption1></StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        </Tooltip>
                    }

                    <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Manage View </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </>
    };


    var dataArr: any = [];
    useEffect(() => {
        contextValue.selectedRowIdInSubTable.map((val: any, i: any) => {
            dataArr.push({
                id: i,
                checkbox: "hide",
                selected: { label: <Caption1> {val} </Caption1>, id: `${i}` },
            });
        });

        dataArr.length > 0 ? setSelectedTableData(dataArr) : setSelectedTableData([]);
        contextValue.selectedRowIdInTable.length > 0 ? setIconEnabled(true) : setIconEnabled(false);
    }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

    const generateQueries = (data: any) => {
        const createCondition = (condition: any) => {
            const field = condition["Select the asset from the dropdown"];
            const operator = condition.lastCondition.ConditionType;
            const renderOperator = operator === 'like start%' ? 'like' : operator === 'like %end' ? 'like' : operator;
            const conditionValues = condition.lastCondition.ConditionValue
            const value = operator === 'like' ? `%${conditionValues}%` :
                operator === 'not like' ? `%%${conditionValues}` :
                    operator === 'like start%' ? `${conditionValues}%` :
                        operator === 'like %end' ? `%${conditionValues}` :
                            conditionValues;
            const addOperator = condition.lastCondition?.Add === undefined ? '' : condition.lastCondition?.Add;
            // Base condition
            let query = `(${field} ${renderOperator} '${value}') ${addOperator}`;

            // Traverse `nextCondition` if it exists
            let next = condition.lastCondition.nextCondition;
            while (next) {
                const nextOperator = next.ConditionType;
                const nextRenderOperator = nextOperator === 'like start%' ? 'like' : nextOperator === 'like %end' ? 'like' : nextOperator;
                const nextconditionValues = next.ConditionValue
                const nextValue = nextOperator === 'like' ? `%${nextconditionValues}%` :
                    nextOperator === 'not like' ? `%%${nextconditionValues}` :
                        nextOperator === 'like start%' ? `${nextconditionValues}%` :
                            nextOperator === 'like %end' ? `%${nextconditionValues}` :
                                nextconditionValues;
                const add = next.Add === undefined ? '' : ` ${next.Add}`;
                query += ` (${field} ${nextRenderOperator} '${nextValue}')${add}`;
                next = next.nextCondition;
            }

            return query;
        };

        return data?.conditional?.map((item: any) => {
            const dataName = item["Select Data Name"];
            const conditions = item?.conditionals?.map((cond: any) => createCondition(cond))
                .join(" and ");

            return `(dataid = ${dataName} and (${conditions}))`;
        }).join(" and ");
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
    }

    const handleError = (errors: any) => {
        const filteredErrors = errors.reduce((acc: any, error: any) => {
            if (!acc.find((e: any) => e.property === error.property)) {
                acc.push(error);
            }
            return acc;
        }, []);

        console.log("Filtered Errors:", filteredErrors);
    };

    const handleSubmits = () => {
        if (formRef.current) {
            const submit = formRef.current.submit(); // Programmatically trigger form submission
            console.log("submit", submit)
        }
    };

    useEffect(() => {

        setOverLayData({
            size: "large",
            isTabs: true,
            headerTitle:
                (
                    <>
                        <FluentProvider theme={dashboardTheme}>
                            <Title3> Asset Query </Title3>
                        </FluentProvider>
                    </>
                ),
            tabItems: {
                Introduction: <Stack verticalFill tokens={{ padding: '10px 0px 0px 0px' }}>
                    <form id='myFormAutoheal' onSubmit={handleSubmit} style={dividerWidthStyle}>
                        <Stack style={dividerWidthStyle}>
                            <Stack verticalFill tokens={{ childrenGap: 10 }}>
                                <Stack verticalFill tokens={{ childrenGap: '8px' }} style={dividerWidthStyle}>
                                    <p><b>Name<Image src="/Dashboard/image/required.svg" /></b></p>
                                    <Input
                                        size="small"
                                        value={formData?.name}
                                        style={inputFieldCSS}
                                        onChange={(e) => setFormData((prev: any) => ({ ...prev, name: e.target.value }))}
                                        required={true}
                                    />
                                </Stack>
                                <Stack verticalFill tokens={{ childrenGap: '8px' }} style={dividerWidthStyle}>
                                    <p><b>What is the benfit?</b></p>
                                    <Textarea
                                        size="small"
                                        value={formData?.description}
                                        onChange={(e) => setFormData((prev: any) => ({ ...prev, description: e.target.value }))}
                                    />
                                </Stack>
                            </Stack>
                            <InfoBar showSpaces={true} title={"These details will make it easy to find the snippets later when you need to use them."} />
                            {/* <Stack style={formData.name !== "" ? { display: 'none' } : { ...buttonDisabled }}> <Button shape="circular" appearance="primary"
                                size="small" type='submit'>Next</Button>
                            </Stack> */}
                            <Stack verticalFill tokens={{ childrenGap: 10 }}>
                                <StackItem> <p><b> What is the benefit? </b></p> </StackItem>
                                <StackItem><Body1 align='justify'>Running an asset query helps manage and track devices efficiently by providing real-time insights, ensuring data accuracy, and supporting troubleshooting. It ensures compliance by tracking asset configurations, identifies security risks, optimizes resource use, and helps with cost management by flagging unused assets. Regular queries also maintain accurate inventory control, ensuring all assets are accounted for and up-to-date.</Body1></StackItem>
                            </Stack>
                        </Stack>
                        <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
                    </form>
                </Stack>
                ,
                "Configure": <Stack verticalFill >
                    <InfoBar showSpaces={true} title={"Choose the filter criteria to search for assets. Specify the starting date (From Date) for the search. To perform a real-time query, leave the To Date field blank. If no To Date is selected, the query will continuously update with new data as it becomes available."} />
                    <Stack verticalFill tokens={{ childrenGap: 20 }} style={dividerWidthStyle}>
                        <Stack verticalFill tokens={{ childrenGap: '20' }} style={dividerWidthStyle}>
                            <Stack verticalFill tokens={{ childrenGap: '20' }}>
                                <Form
                                    onError={handleError}
                                    key={JSON.stringify(jsonData)}
                                    id="SearchForm"
                                    ref={formRef}
                                    formData={formData.jsonData}
                                    schema={jsonData}
                                    validator={validator}
                                    uiSchema={uiData}
                                    widgets={CustomWidgets}
                                    transformErrors={(errors) =>
                                        errors.filter(
                                            (err, index, self) =>
                                                index === self.findIndex((e) => e.stack === err.stack)
                                        )
                                    }
                                    onChange={(e) => handleNewFormChange(e)} />
                                {/* <button onClick={handleSubmits}>Submit</button> */}
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>,
                "Review and Create": <Stack verticalFill>
                    <InfoBar showSpaces={true} title={"Choose the filter criteria to search for assets. Specify the starting date (From Date) for the search. To perform a real-time query, leave the To Date field blank. If no To Date is selected, the query will continuously update with new data as it becomes available."} />
                    <Stack verticalFill tokens={{ childrenGap: 20 }} style={dividerWidthStyle}>
                        <Stack verticalFill tokens={{ childrenGap: '20' }} style={dividerWidthStyle}>
                            <Stack verticalFill tokens={{ childrenGap: '20' }}>
                                <Form key={JSON.stringify(jsonData)} id="SearchForm" disabled formData={formData.jsonData} schema={jsonData} uiSchema={uiData} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange(e)} />
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>,
            },
        });
    }, [devicesTableData, selectedTableData, isChecked, dropDownValue1Overlay, dropDownValue2Overlay, filterMenuOpenOverlay, filterArray, isfilter, jsonData, formData]);

    useEffect(() => {
        searchVal.length === 0 && !loadTableData && setLoadTableData(true);
    }, [searchVal]);

    useEffect(() => {
        contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
    }, [contextValue.selectedRowIdInTable]);

    useEffect(() => {
        const pageNo = (currentPageNo - 1) * 50;

        const props = {
            func: set_final_data,
            data: final_data,
            pageNo: pageNo,
            jsonData: jsonData,
            setJsonData: setJsonData,
            uiData: uiData,
            setUiData: setUiData,
            saveBtnClicked: saveBtnClicked,
            setSaveBtnClicked: setSaveBtnClicked,
            setEditBtnClicked: setEditBtnClicked,
            setToastAlertCreate: setToastAlertCreate,
            setToastAlertEdit: setToastAlertEdit,
            editBtnClicked: editBtnClicked,
            rowID: rowID,
            setRowID: setRowID,
            setOverlayName: setOverlayName,
            setToastAlertDelete: setToastAlertDelete,
            setTotalPages: setTotalPages,
            setTotalRecords: setTotalRecords,
            totalRecords: totalRecords,
            isRefresh: isRefresh,
            setIsRefresh: setIsRefresh,
            setExportDetails: setExportDetails,
            importedDataInserted: importedDataInserted,
            searchVal: searchVal,
            setSearchVal: setSearchVal,
            setToastAlertError: setToastAlertError,
            filterArray: filterArray,
            isfilter: isfilter,
            tenant: tenantName,
            setExportBtnClicked: setExportBtnClicked,
            exportBtnClicked: exportBtnClicked,
            formData: formData,
            setFormData: setFormData,
            setTroubleshooterList: setTroubleshooterList,
            selectedTroubleshooterList: selectedTroubleshooterList,
            overlayOpen: overlayOpen,
            selectedAsset: selectedAsset,
            loadTableData: loadTableData,
            setLoadTableData: setLoadTableData,
            setDartList: setDartList,
            dartList: dartList,
            selectedRowIdInTable: contextValue.selectedRowIdInTable,
            setSelectedRowIdInTable: contextValue.setSelectedRowIdInTable,
            overlayName: overlayName,
            JsonData: jsonData,
            setErrorToast: setErrorToast,
            setToastMessage: setToastMessage,
            setOverlayOpen: setOverlayOpen,
            setIsToast: setIsToast,
            setDeleteAsset: setDeleteAsset,
            deleteAsset: deleteAsset,
            setDeleteDisabled: setDeleteDisabled,
            type: 'asset',
        };

        if ((!saveBtnClicked && overlayName === '') || (!saveBtnClicked && (overlayName === 'editAsset' || overlayName === 'addAsset')) || (saveBtnClicked && overlayName !== '')) {
            Asset_event_func(props);
        }
    }, [isfilter, filterArray, importedDataInserted, /*jsonData, uiData,*/ saveBtnClicked, rowID, editBtnClicked, isRefresh, searchVal, loadTableData, dartList, selectedAsset, deleteAsset, exportBtnClicked]);

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                        <Stack tokens={{childrenGap:5}} horizontalAlign="start">
                            <StackItem><Text></Text></StackItem>
                            <StackItem grow shrink>
                            <Breadcrumbs
                                items={[
                                {name: "Manage", link: "/home" },
                                {name:"Search", link:"#"},
                                {name:"Asset", link:"#"},
                                ]} 
                            /> 
                            </StackItem>
                        </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>

                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={parentHome}>
                            {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                        <StackItem> <Text></Text> </StackItem>
                                <StackItem>
                                    <FluentProvider theme={dashboardTheme}>
                                        <Title3> Search | Asset </Title3>
                                    </FluentProvider>
                                </StackItem>
                            </Stack> */}
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={SearchPages("Asset")} />
                                    <StackItem style={dividerWidthStyle}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                <Divider />
                                            </StackItem>
                                            <StackItem style={wraperStyle}>
                                                <StackItem>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                            <StackItem>
                                                            <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"First Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn={
                                                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                            {loading || tableData.length === 0 ? <FilterAdd20Filled {...secondaryIcon} /> : <FilterAdd20Filled {...primaryIcon} />}
                                                                            <Body1> Filter </Body1>
                                                                        </Stack>
                                                                    </MenuButton>
                                                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                                                    <Divider />
                                                                    <MenuList>
                                                                        <Stack tokens={{ childrenGap: 5 }}>
                                                                            <StackItem> <Text></Text> </StackItem>
                                                                            <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                            {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                                                            {dropDownValue1 === "Created By" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                                                            {(dropDownValue1 === "Query name" || dropDownValue1 === "Created By" || dropDownValue1 === "Description") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                <StackItem>
                                                                                    <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                        disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                                                        <Caption1> Apply </Caption1>
                                                                                    </Button>
                                                                                </StackItem>

                                                                                <StackItem>
                                                                                    <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                        <Caption1> Cancel </Caption1>
                                                                                    </Button>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </MenuList>
                                                                </>} />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setLoadTableData(true); setLoading(true); setIsOverlayFilter(false); setFilterArray([]); setIsFilter(false); setDropDownValue2Overlay(''); setResetDisabled(true); }}>
                                                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>
                                                    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 8px' }}>
                                                        <StackItem>
                                                            {filterArray.length > 0 && (
                                                                <Stack horizontal wrap>
                                                                    {filterArray.map((item, index) => (
                                                                        <Button shape="circular" size="small">
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                <StackItem>
                                                                                    <Stack tokens={{ childrenGap: 1 }}>
                                                                                        <StackItem><Text></Text></StackItem>
                                                                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                    </Stack>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Button>
                                                                    ))}
                                                                </Stack>
                                                            )}
                                                        </StackItem>

                                                        <StackItem disableShrink>
                                                            {(tableData.length > 0 && !loading) && (
                                                                totalRecords > 0 &&
                                                                <Caption1>
                                                                    Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                                                </Caption1>
                                                            )}
                                                        </StackItem>
                                                    </Stack>
                                                </StackItem>
                                                <InfoBar showSpaces={true} title={"Choose the filter criteria to search for assets, the query will continuously update with new data as it becomes available."} />
                                                
                                            </StackItem>

                                            {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                                            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={toastMessage} footer="" />}

                                            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}
                                            {loading ? (<SkeletonDataTable />) :
                                                (tableData.length > 0 ?
                                                    (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>)}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} saveBtnFunc={setSaveBtnClicked} overlayData={overLayData} isNavBtn={true} classificationNameValidation={classificationNameValidation} handleOutsideButton={handleOutsideButton} handleSubmit={handleSubmit} formRef={formRef} />

                        {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveBtnClicked && overlayName === '' && deleteAsset) ? "Asset Data Deleted Successfully" : overlayName === 'addAsset' ? "New Asset Data Created Successfully" : "Asset Data Edited Successfully"} footer="" />}

                        {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}

                        {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                    </StackItem>
                    <StackItem><Text></Text></StackItem>
                </Stack>
            </FullScreen>
        </>
    )
}

export default Asset;